export const esDict = {
  'Account recovery requires verified contact information':
    'La recuperación de la cuenta requiere información de contacto verificada',
  'Back to Sign In': 'Volver a inicio de sesión',
  'Change Password': 'Cambiar contraseña',
  Code: 'Código',
  Confirm: 'Confirmar',
  'Confirm a Code': 'Confirmar un código',
  'Confirm Password': 'Confirmar contraseña',
  'Confirm Sign In': 'Confirmar inicio de sesión',
  'Confirm Sign Up': 'Confirmar registro',
  'Confirmation Code': 'Código de confirmación',
  'Create a new account': 'Crear una cuenta nueva',
  Email: 'Email',
  'Forgot Password': 'Olvidé mi contraseña',
  'Incorrect username or password': 'Nombre de usuario o contraseña incorrecta',
  'Invalid password format': 'Formato de contraseña inválido',
  'Invalid phone number format': 'Formato de número de teléfono inválido',
  'Loading...': 'Cargando...',
  'New Password': 'Nueva contraseña',
  or: 'o',
  Password: 'Contraseña',
  'Phone Number': 'Número de teléfono',
  'Resend a Code': 'Reenviar un código',
  'Resend Code': 'Reenviar código',
  'Send Code': 'Enviar código',
  'Sign In': 'Iniciar sesión',
  'Sign in to your account': 'Iniciar sesión en tu cuenta',
  'Sign Out': 'Cerrar sesión',
  'Sign Up': 'Crear cuenta',
  Skip: 'Omitir',
  Submit: 'Enviar',
  'User already exists': 'El usuario ya existe',
  'User does not exist': 'El usuario no existe',
  Username: 'Nombre de usuario',
  'Username cannot be empty': 'El nombre de usuario no puede estar vacío',
  Verify: 'Verificar',
  'Verify Contact': 'Verificar contacto',
};
